import axios from 'axios'

export default class CorreiosService {
  static async getByCep(cep) {
    return axios.get(`https://viacep.com.br/ws/${cep}/json`).then(res => res.data)
  }
}
